/**
 * Format numbers with Western digits (0-9) in all locales.
 * Use for counts, amounts, percentages, etc., so Arabic and other locales
 * always display 1234567890 instead of locale-specific numerals.
 *
 * @param {number|string} value - Number to format
 * @param {{ maximumFractionDigits?: number, minimumFractionDigits?: number }} [options]
 * @returns {string}
 */
export function formatNumber(value, options = {}) {
  const num = typeof value === 'number' ? value : parseFloat(value);
  if (Number.isNaN(num)) return '0';
  try {
    return new Intl.NumberFormat('en-US', {
      numberingSystem: 'latn',
      maximumFractionDigits: options.maximumFractionDigits ?? 2,
      minimumFractionDigits: options.minimumFractionDigits,
    }).format(num);
  } catch {
    return String(num);
  }
}

/**
 * Format an integer with Western digits (e.g. order counts).
 * @param {number|string} value
 * @returns {string}
 */
export function formatInteger(value) {
  return formatNumber(value, { maximumFractionDigits: 0 });
}
